import type { ReactNode } from 'react'

type BenefitItem =
  | string
  | { text: string; emphasis?: boolean; suffix?: string }

function renderBenefit(item: BenefitItem): ReactNode {
  if (typeof item === 'string') {
    return item
  }
  if (item.emphasis) {
    return (
      <>
        <strong className="font-semibold text-text-primary">{item.text}</strong>
        {item.suffix ?? ''}
      </>
    )
  }
  return item.text
}

export interface SubscriptionBenefitListProps {
  items: readonly BenefitItem[]
  compact?: boolean
}

export function SubscriptionBenefitList({ items, compact = false }: SubscriptionBenefitListProps) {
  return (
    <ul className={`list-none m-0 p-0 flex-1 ${compact ? 'mb-3' : 'mb-4'}`}>
      {items.map((item) => (
        <li
          key={typeof item === 'string' ? item : item.text}
          className="flex gap-2 items-start text-small text-text-secondary mb-2 leading-snug"
        >
          <span className="text-brand-primary font-bold shrink-0 mt-px" aria-hidden>
            ✓
          </span>
          <span>{renderBenefit(item)}</span>
        </li>
      ))}
    </ul>
  )
}
